// extracted by mini-css-extract-plugin
module.exports = {"chartControls":"onGoingChart_chartControls__3W6p8","chartItem":"onGoingChart_chartItem__1B-h1","hiddenText":"onGoingChart_hiddenText__PSEp1"};